import type { MdComponentIndexProps } from '../type';
import styles from './Frame.module.less';

function MarkdownFrame(
  props: React.PropsWithChildren<
    {
      caption?: string;
    } & MdComponentIndexProps
  >,
) {
  return (
    <div
      className={styles.Frame}
      data-markdown-component="x-frame-container"
      data-first={props['data-first']}
      data-last={props['data-last']}
    >
      <div className={styles.FrameContent}>{props.children}</div>
      {props.caption ? <div className={styles.FrameCaption}>{props.caption}</div> : null}
    </div>
  );
}

MarkdownFrame.attributes = ['caption'];

export { MarkdownFrame };
